import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";
import { STATUS_HEX } from "@/lib/format";

const TT = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-md border border-slate-300 bg-white p-3 text-xs shadow-xl">
      <div className="font-semibold mb-1">{label} · {d.shift}</div>
      {d.records === 0 ? <div className="text-slate-500">{d.due ? "⚫ Missing submission" : "Not yet due"}</div> : (
        <div className="font-mono space-y-0.5 text-slate-700">
          <div>Target {d.target} · Actual {d.actual} ({d.achievement_pct}%)</div>
          <div>OEE {d.oee}% · FPY {d.fpy}%</div>
          <div>Downtime {d.downtime_min}m · Defects {d.defects}</div>
          {d.missing > 0 && <div className="text-rose-600">{d.missing} line(s) missing</div>}
        </div>
      )}
    </div>
  );
};

export function TrendChart({ data }) {
  return (
    <div className="h-72 w-full min-h-[288px]" data-testid="trend-chart">
      <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 600, height: 240 }} minHeight={200}>
        <ComposedChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid stroke="#E2E8F0" vertical={false} />
          <XAxis dataKey="label" tick={{ fill: "#64748B", fontSize: 11, fontFamily: "IBM Plex Mono" }} interval={0} angle={-30} textAnchor="end" height={50} />
          <YAxis yAxisId="l" tick={{ fill: "#64748B", fontSize: 11, fontFamily: "IBM Plex Mono" }} />
          <YAxis yAxisId="r" orientation="right" tick={{ fill: "#64748B", fontSize: 11, fontFamily: "IBM Plex Mono" }} />
          <Tooltip content={<TT />} cursor={{ fill: "rgba(148,163,184,0.08)" }} />
          <Legend wrapperStyle={{ fontSize: 12, color: "#64748B" }} />
          <Bar yAxisId="l" dataKey="target" name="Target" fill="#CBD5E1" radius={[3, 3, 0, 0]} />
          <Bar yAxisId="l" dataKey="actual" name="Actual" radius={[3, 3, 0, 0]}>
            {data.map((d, i) => <Cell key={i} fill={STATUS_HEX[d.status] || "#3B82F6"} />)}
          </Bar>
          <Line yAxisId="r" type="monotone" dataKey="downtime_min" name="Downtime (min)" stroke="#0EA5E9" strokeWidth={2} dot={{ r: 3 }} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
